import { getAxiosClient } from "../axios-client";
import { WarehousesAvailabilityExcelUpdateBody, WarehousesAvailabilityExcelUpdateResponse } from "./types";

const axiosClient = getAxiosClient();
export const updateWarehousesAvailabilityExcel = async (body: WarehousesAvailabilityExcelUpdateBody) => {
    return await axiosClient.ax
    .put<WarehousesAvailabilityExcelUpdateResponse>("/Availability/UpdateExcel", body,{headers: {'content-type': 'multipart/form-data'}})
  };
  